import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import MediaLibrary from "@/pages/MediaLibrary";
import ArticleDetail from "@/pages/ArticleDetail";
import SearchResults from "@/pages/SearchResults";
import {
  WarCrimes,
  TerrorCrimes,
  Monitoring,
  Studies,
  Analysis,
  News,
  Director,
  Publications,
} from "@/pages/Sections";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminShell from "@/pages/admin/AdminShell";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminArticles from "@/pages/admin/AdminArticles";
import AdminArticleEditor from "@/pages/admin/AdminArticleEditor";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminInbox from "@/pages/admin/AdminInbox";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";

function PublicRoutes() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/war-crimes" element={<WarCrimes />} />
        <Route path="/terror-organizations" element={<TerrorCrimes />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/studies" element={<Studies />} />
        <Route path="/analysis" element={<Analysis />} />
        <Route path="/news" element={<News />} />
        <Route path="/director" element={<Director />} />
        <Route path="/media" element={<MediaLibrary />} />
        <Route path="/publications" element={<Publications />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/article/:slug" element={<ArticleDetail />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminShell />}>
          <Route index element={<AdminDashboard />} />
          <Route path="articles" element={<AdminArticles />} />
          <Route path="articles/new" element={<AdminArticleEditor />} />
          <Route path="articles/:id" element={<AdminArticleEditor />} />
          <Route path="media" element={<AdminMedia />} />
          <Route path="inbox" element={<AdminInbox />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
        </Route>
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <PublicRoutes />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
